import { createRouter, createWebHistory } from 'vue-router';
import UserLogin from '../views/components/UserLogin.vue';
import AzureADOProjects from '../views/components/AzureADOProjects.vue';
import PipelinesList from '../views/components/PipelinesList.vue';
import AssociatedPipelines from '../views/components/AssociatedPipelines.vue';
import FetchJsonFiles from '../views/components/FetchJsonFiles.vue';
import StorageTableViewer from '../views/components/StorageTableViewer.vue';
import CreateAzureStorageTable from '../views/components/CreateAzureStorageTable.vue';
import UpdateExistingTable from '../views/components/UpdateExistingTable.vue';
import OnBoardAppDeployClient from '../views/components/OnBoardAppDeployClient.vue';
import OnBoardAppDeployClientv2 from '../views/components/OnBoardAppDeployClientv2.vue';
import TenantBaselineOptions from '../views/components/TenantBaselineOptions.vue'
import ViewAppList from '../views/components/ViewAppList.vue'
import ClientPipelineSchedules from '../views/components/ClientPipelineSchedules.vue'
import { msalInstance } from '../auth';
import TenantBackup from '../views/components/TenantBackup.vue';
import ClientCaptureManagement from '../views/ClientCaptureManagement.vue';
import TriggerCapture from '../views/components/capture/TriggerCapture.vue';
import JITAdminProcess from '../views/components/JITAdminProcess.vue';
import NetskopeBaseline from '../views/components/NetskopeBaseline.vue';
import EntraPortfolio from '../views/entra/EntraPortfolio.vue';
import EntraTenantOverview from '../views/entra/EntraTenantOverview.vue';
import EntraUsers from '../views/entra/EntraUsers.vue';
import EntraLicences from '../views/entra/EntraLicences.vue';
import EntraGroups from '../views/entra/EntraGroups.vue';
import EntraSecurity from '../views/entra/EntraSecurity.vue';
import EntraApplications from '../views/entra/EntraApplications.vue';
import EntraActivity from '../views/entra/EntraActivity.vue';
import EntraRecommendations from '../views/entra/EntraRecommendations.vue';
import EntraReports from '../views/entra/EntraReports.vue';
import EntraTenantSettings from '../views/entra/EntraTenantSettings.vue';
import EntraConditionalAccess from '../views/entra/EntraConditionalAccess.vue';
import EntraAuthenticationMethods from '../views/entra/EntraAuthenticationMethods.vue';
import EntraSignInLogs from '../views/entra/EntraSignInLogs.vue';
import EntraIntune from '../views/entra/EntraIntune.vue';
import EntraIntuneDevices from '../views/entra/EntraIntuneDevices.vue';
import EntraIntuneCompliance from '../views/entra/EntraIntuneCompliance.vue';
import EntraIntuneConfigs from '../views/entra/EntraIntuneConfigs.vue';
import EntraIntuneAppProtection from '../views/entra/EntraIntuneAppProtection.vue';
import EntraTeams from '../views/entra/EntraTeams.vue';
import BillingDashboard from '../views/billing/BillingDashboard.vue';
import BillingInvoices from '../views/billing/BillingInvoices.vue';
import BillingCustomers from '../views/billing/BillingCustomers.vue';
import InternalBilling from '../views/billing/InternalBilling.vue';
import ReconProcessing from '../views/billing/ReconProcessing.vue';
import ReconConfig from '../views/billing/ReconConfig.vue';
import ReconOverview from '../views/billing/ReconOverview.vue';
import ReconProfitability from '../views/billing/ReconProfitability.vue';
import PresalesHandoverForm from '../views/presales/PresalesHandoverForm.vue';
import PresalesSubmissions from '../views/presales/PresalesSubmissions.vue';
import OnboardingBoard from '../views/presales/OnboardingBoard.vue';
import OnboardingBoards from '../views/presales/OnboardingBoards.vue';
import CyanicAssistantChat from '../views/CyanicAssistantChat.vue';

const routes = [
  {
    path: '/',
    name: 'UserLogin',
    component: UserLogin,
  },
  {
    path: '/azure-ado-projects',
    name: 'AzureADOProjects',
    component: AzureADOProjects,
    meta: { requiresAuth: true },
  },
  {
    path: '/pipelines-list',
    name: 'PipelinesList',
    component: PipelinesList,
    meta: { requiresAuth: true },
  },
  {
    path: '/associated-pipelines/:projectName/:projectId',
    name: 'AssociatedPipelines',
    component: AssociatedPipelines,
    meta: { requiresAuth: true },
  },
  {
    path: '/fetch-json-files',
    name: 'FetchJsonFiles',
    component: FetchJsonFiles,
    meta: { requiresAuth: true },
  },
  {
    path: '/JIT-Admin-Process',
    name: 'JITAdminProcess',
    component: JITAdminProcess,
    meta: { requiresAuth: true },
  },
  {
    path: '/storage-tables-list',
    name: 'StorageTableViewer',
    component: StorageTableViewer,
    meta: { requiresAuth: true },
  },
  {
    path: '/Create-Azure-Storage-Table',
    name: 'CreateAzureStorageTable',
    component: CreateAzureStorageTable,
    meta: { requiresAuth: true },
  },
  {
    path: '/update-existing-table',
    name: 'update-existing-table',
    component: UpdateExistingTable,
    meta: { requiresAuth: true },
  },
  {
    path: '/AppDeploy-Onboarding',
    name: 'AppDeploy-Onboarding',
    component: OnBoardAppDeployClient,
    meta: { requiresAuth: true },
  },
  {
    path: '/AppDeploy-Onboarding-New',
    name: 'AppDeploy-Onboarding-New',
    component: OnBoardAppDeployClientv2,
    meta: { requiresAuth: true },
  },
  {
    path: '/tenant-baseline-options',
    name: 'TenantBaselineOptions',
    component: TenantBaselineOptions,
    meta: { requiresAuth: true },
  },
  {
    path: '/tenant-backup',
    name: 'TenantBackup',
    component: TenantBackup,
    meta: { requiresAuth: true },
  },
  {
    path: '/ViewAppList',
    name: 'ViewAppList',
    component: ViewAppList,
    meta: { requiresAuth: true },
  },
  {
    path: '/ClientPipelineSchedules',
    name: 'ClientPipelineSchedules',
    component: ClientPipelineSchedules,
    meta: { requiresAuth: true },
  },
  {
    path: '/netskope-baseline',
    name: 'NetskopeBaseline',
    component: NetskopeBaseline,
    meta: { requiresAuth: true },
  },
  {
    path: '/cis-benchmark',
    name: 'CisBenchmark',
    component: FetchJsonFiles,
    meta: { requiresAuth: true },
  },

  {
    path: '/entra/portfolio',
    name: 'EntraPortfolio',
    component: EntraPortfolio,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/overview',
    name: 'EntraTenantOverview',
    component: EntraTenantOverview,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/users',
    name: 'EntraUsers',
    component: EntraUsers,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/licences',
    name: 'EntraLicences',
    component: EntraLicences,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/groups',
    name: 'EntraGroups',
    component: EntraGroups,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/security',
    name: 'EntraSecurity',
    component: EntraSecurity,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/conditional-access',
    name: 'EntraConditionalAccess',
    component: EntraConditionalAccess,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/authentication-methods',
    name: 'EntraAuthenticationMethods',
    component: EntraAuthenticationMethods,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/sign-in-logs',
    name: 'EntraSignInLogs',
    component: EntraSignInLogs,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/intune',
    name: 'EntraIntune',
    component: EntraIntune,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/intune/devices',
    name: 'EntraIntuneDevices',
    component: EntraIntuneDevices,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/intune/compliance',
    name: 'EntraIntuneCompliance',
    component: EntraIntuneCompliance,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/intune/configs',
    name: 'EntraIntuneConfigs',
    component: EntraIntuneConfigs,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/intune/app-protection',
    name: 'EntraIntuneAppProtection',
    component: EntraIntuneAppProtection,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/teams',
    name: 'EntraTeams',
    component: EntraTeams,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/applications',
    name: 'EntraApplications',
    component: EntraApplications,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/activity',
    name: 'EntraActivity',
    component: EntraActivity,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/recommendations',
    name: 'EntraRecommendations',
    component: EntraRecommendations,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/reports',
    name: 'EntraReports',
    component: EntraReports,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/settings',
    name: 'EntraTenantSettings',
    component: EntraTenantSettings,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/users',
    name: 'EntraUsersWithTenant',
    component: EntraUsers,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/licences',
    name: 'EntraLicences',
    component: EntraLicences,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/licences',
    name: 'EntraLicencesWithTenant',
    component: EntraLicences,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/groups',
    name: 'EntraGroups',
    component: EntraGroups,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/groups',
    name: 'EntraGroupsWithTenant',
    component: EntraGroups,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/security',
    name: 'EntraSecurity',
    component: EntraSecurity,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/security',
    name: 'EntraSecurityWithTenant',
    component: EntraSecurity,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/applications',
    name: 'EntraApplications',
    component: EntraApplications,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/applications',
    name: 'EntraApplicationsWithTenant',
    component: EntraApplications,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/activity',
    name: 'EntraActivity',
    component: EntraActivity,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/activity',
    name: 'EntraActivityWithTenant',
    component: EntraActivity,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/recommendations',
    name: 'EntraRecommendations',
    component: EntraRecommendations,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/recommendations',
    name: 'EntraRecommendationsWithTenant',
    component: EntraRecommendations,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/reports',
    name: 'EntraReports',
    component: EntraReports,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/reports',
    name: 'EntraReportsWithTenant',
    component: EntraReports,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/settings',
    name: 'EntraTenantSettings',
    component: EntraTenantSettings,
    meta: { requiresAuth: true },
  },
  {
    path: '/entra/tenants/:tenantId/settings',
    name: 'EntraTenantSettingsWithTenant',
    component: EntraTenantSettings,
    meta: { requiresAuth: true },
  },

  {
    path: '/billing/dashboard',
    name: 'BillingDashboard',
    component: BillingDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/billing/invoices',
    name: 'BillingInvoices',
    component: BillingInvoices,
    meta: { requiresAuth: true },
  },
  {
    path: '/billing/regions/:regionCode/invoices',
    name: 'BillingInvoicesWithRegion',
    component: BillingInvoices,
    meta: { requiresAuth: true },
  },
  {
    path: '/billing/customers',
    name: 'BillingCustomers',
    component: BillingCustomers,
    meta: { requiresAuth: true },
  },
  {
    path: '/billing/regions/:regionCode/customers',
    name: 'BillingCustomersWithRegion',
    component: BillingCustomers,
    meta: { requiresAuth: true },
  },
  {
    path: '/billing/internal',
    name: 'InternalBilling',
    component: InternalBilling,
    meta: { requiresAuth: true },
  },
  {
    path: '/billing/recon',
    name: 'ReconProcessing',
    component: ReconProcessing,
    meta: { requiresAuth: true },
  },
  {
    path: '/billing/recon/config',
    name: 'ReconConfig',
    component: ReconConfig,
    meta: { requiresAuth: true },
  },
  {
    path: '/billing/recon/overview',
    name: 'ReconOverview',
    component: ReconOverview,
    meta: { requiresAuth: true },
  },
  {
    path: '/billing/recon/profitability',
    name: 'ReconProfitability',
    component: ReconProfitability,
    meta: { requiresAuth: true },
  },

  {
    path: '/presales/handover',
    name: 'PresalesHandoverForm',
    component: PresalesHandoverForm,
    meta: { requiresAuth: true },
  },

  {
    path: '/presales/submissions',
    name: 'PresalesSubmissions',
    component: PresalesSubmissions,
    meta: { requiresAuth: true },
  },
  {
    path: '/presales/submissions/:submissionId',
    name: 'PresalesSubmissionDetail',
    component: PresalesSubmissions,
    meta: { requiresAuth: true },
  },
  {
    path: '/presales/onboarding',
    name: 'OnboardingBoards',
    component: OnboardingBoards,
    meta: { requiresAuth: true },
  },
  {
    path: '/presales/onboarding/:boardId',
    name: 'OnboardingBoard',
    component: OnboardingBoard,
    meta: { requiresAuth: true },
  },

  {
    path: '/capture-management',
    name: 'ClientCaptureManagement',
    component: ClientCaptureManagement,
    meta: { requiresAuth: true }
  },

  {
    path: '/capture-management/:clientCode',
    name: 'ClientCaptureManagementWithClient',
    component: ClientCaptureManagement,
    meta: { requiresAuth: true }
  },

  {
    path: '/trigger-capture',
    name: 'TriggerCapture',
    component: TriggerCapture,
    meta: { requiresAuth: true }
  },
  {
    path: '/chat',
    name: 'CyanicAssistantChat',
    component: CyanicAssistantChat,
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuthenticated = msalInstance.getAllAccounts().length > 0;

  if (requiresAuth && !isAuthenticated) {
    next('/');
  } else {
    next();
  }
});

export default router;